/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen., Ryan Duffy & Warren Dowey
 */
declare const require: any;
import * as process from 'process';
import 'core-js/es';
import 'core-js/es/reflect';
require('zone.js');
(window as any).global = window;
window['process'] = process;

const environment = (process.env.NODE_ENV || 'production').trim();

if (environment === 'production') {
  // Production
} else {
  // Development and test
  // Error['stackTraceLimit'] = Infinity;
  // require('zone.js/dist/long-stack-trace-zone');
}
